import React, { useState } from 'react';
import axios from 'axios';
import endpoints from '../../define/endpoints';
import ModalDrawer from './ModalDrawer';
import Button, { ButtonSizes, ButtonStyles } from '../Button/Button';
import { BREAKPOINTS } from '../../../constants';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { ModalOrderCard } from './subComponents/ModalOrderCard';
import { TRANSLATIONS } from '../../../translations';
import { BetaTextInput } from '../BetaTextInput';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import { ModalDrawerResponse } from './ModalDrawerResponse';
import { useForm } from 'react-hook-form';
import { returnHubspotCustomerFormId } from '../../../constants';

const ModalOrderIssue = ({ isOpen, setIsOpen, order, token }) => {
  if (!order || !token) return null;

  const HUBSPOT_FORM_ID = returnHubspotCustomerFormId;

  const orderId = order.id;
  const modalTitle = TRANSLATIONS.REPORT_PROBLEM;
  const [issueDescription, setIssueDescription] = useState('');
  const [issueDescriptionError, setIssueDescriptionError] = useState(null);
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_LANDSCAPE
  );
  const [responseModal, setResponseModal] = useState({
    isOpen: false,
    isSuccess: false,
    responseContent: '',
    modalTitle: '',
  });
  const { register } = useForm();

  const handleClose = () => {
    setIsOpen(false);
  };

  const onSubmit = async () => {
    if (!issueDescription || issueDescription === '') {
      setIssueDescriptionError(TRANSLATIONS.MOTIVATION_ERROR);
      return;
    }

    try {
      await axios.post(
        `${endpoints.core}/form-requests`,
        {
          order_id: orderId,
          message: `#:${orderId} - ${issueDescription}`,
          hubspot_form_id: HUBSPOT_FORM_ID,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setResponseModal({
        isOpen: true,
        isSuccess: true,
        responseContent: TRANSLATIONS.FEEDBACK_RECEIVED,
        modalTitle: modalTitle,
      });
    } catch (error) {
      setResponseModal({
        isOpen: true,
        isSuccess: false,
        responseContent:
          TRANSLATIONS.UNEXPECTED_ERROR_HAS_OCCURRED_PLEASE_RETRY_LATER,
        modalTitle: modalTitle,
      });
    } finally {
      setIsOpen(false);
    }
  };

  const modalBody = (
    <div className="pl-m pr-m pt-xl pb-xl w-100% d-flex flex-column gap-s">
      <Typography
        classNames="text-left"
        variant={TypographyVariants.p2}
        weight={TypographyWeights.bold}
      >
        {TRANSLATIONS.ENCOUNTERED_PROBLEM_WITH_YOUR_ORDER}
      </Typography>
      <ModalOrderCard order={order} compact={true} />
      <Typography
        classNames="text-left"
        variant={TypographyVariants.p3}
        weight={TypographyWeights.bold}
      >
        {TRANSLATIONS.WRITE_WHAT_IT_IS_ABOUT_AND_WE_WILL_HELP_YOU}
      </Typography>

      <form>
        <BetaTextInput
          asTextArea
          className="modal-ord-li-review__review-form__field"
          label={TRANSLATIONS.INSERT_MESSAGE}
          name="orderIssue"
          setRef={register({ required: false, maxLength: { value: 500 } })}
          defaultValue={''}
          onChange={(event) => {
            // const value = event.target.value.replace(
            //   /[^a-zA-Z0-9\s.,!?'-]/g,
            //   ''
            // );
            const value = event.target.value;
            setIssueDescription(value);
          }}
          resize={true}
          limit={500}
          error={issueDescriptionError}
          setError={setIssueDescriptionError}
          errorMessage={issueDescriptionError}
        />
      </form>
      <Typography
        classNames="text-left"
        variant={TypographyVariants.p4}
        state={TypographyStates['neutral-light']}
      >
        {TRANSLATIONS.WE_APPRECIATE_YOUR_FEEDBACK_EVERY_REPORT_HELPS_US_IMPROVE}
      </Typography>
    </div>
  );

  const responseModalDrawer = (
    <ModalDrawerResponse
      isOpen={responseModal.isOpen}
      setIsOpen={setResponseModal}
      isSuccess={responseModal.isSuccess}
      modalTitle={responseModal.modalTitle}
      responseContent={responseModal.responseContent}
      isDeviceSmallerThanTablet={isDeviceSmallerThanMblLandscape}
    />
  );

  return (
    <>
      {responseModal.isOpen && responseModalDrawer}
      <ModalDrawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={modalTitle}
        onClose={handleClose}
        isDeviceSmallerThanTablet={isDeviceSmallerThanMblLandscape}
        content={modalBody}
        footer={
          <div className="d-flex gap-m pb-m pl-xl pr-xl">
            <Button
              classNames={'flex-1 pr-m pl-m'}
              size={ButtonSizes.s}
              style={ButtonStyles.empty}
              label={TRANSLATIONS.CANCEL}
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <Button
              classNames={'flex-1 pr-m pl-m'}
              size={ButtonSizes.s}
              style={ButtonStyles.secondary}
              label={TRANSLATIONS.CONTACT_SEND}
              onClick={onSubmit}
            />
          </div>
        }
      />
    </>
  );
};

export default ModalOrderIssue;
